// Allotment eSign (Aadhaar eSign of the allotment terms via Surepass) before an in-app allotment
// or preselect token payment. Backend: routes/allotmentEsign.js. Every call sends the portal session.
import axios from "axios";
import { portalHeaders, unwrapOtp } from "./ServerOtp";

const base = () => `${process.env.REACT_APP_PAYMENT_LINK_URL}allotment-esign`;
const opts = () => ({ headers: portalHeaders() });

// → { required, title, items: [{ role, isFallback, applicantId, signerName, maskedMobile, termsHtml, openEsign: { allotmentEsignId, url } | null }] }
export const getEsignPending = (allotmentPaymentId) =>
	unwrapOtp(axios.get(`${base()}/pending`, { ...opts(), params: { allotmentPaymentId } }));

// body: { allotmentPaymentId, applicantId? } → { allotmentEsignId, url }
export const startEsign = (body) => unwrapOtp(axios.post(`${base()}/start`, body, opts()));

// → { status, failReason, remaining, signerName }
export const completeEsign = (allotmentEsignId) =>
	unwrapOtp(axios.post(`${base()}/complete`, { allotmentEsignId }, opts()));

// → { status, failReason, signerName }
export const getEsignStatus = (allotmentEsignId) =>
	unwrapOtp(axios.get(`${base()}/status/${encodeURIComponent(allotmentEsignId)}`, opts()));
